import { render } from "./LocaleContainer.vue?vue&type=template&id=a52c40e8"
import script from "./LocaleContainer.vue?vue&type=script&lang=js"
export * from "./LocaleContainer.vue?vue&type=script&lang=js"

import exportComponent from "/home/s-ol/dot/multi/multi-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__